<!-- 预付款申请数据操作 -->
<template>
    <div>
        <subComponents ref="showSelectData"></subComponents>
        <purchaseOrderTemplate ref="purchaseOrderTemplate"></purchaseOrderTemplate>

        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}" @tabHeight="val=>{mxHeight=val}">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="120px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row slot="" v-if="dataActionBox.actionType!=2">
                                            <template v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" >
                                                <el-form-item v-if="formOneValue.isShow==1" :key="formOneKey" :label="formOneValue.showField"
                                                              :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{required: formOneValue.isChange == 1,trigger: ['blur', 'change']}] : []">
                                                    <!-- 记账单号 -->
                                                    <el-input v-if="formOneValue.fieldType == 'extract'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                                                              :id="formOneValue.entityField" @keyup.enter.native="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField,formOneValue.nosetField)"
                                                              :disabled="formOneValue.isChange==0 || dataActionBox.actionType == 1">
                                                        <el-button @click="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField,formOneValue.nosetField)" slot="append" icon="el-icon-search"
                                                                   :disabled="formOneValue.isChange==0 || dataActionBox.actionType == 1">
                                                        </el-button>
                                                    </el-input>
                                                    <el-input v-else-if="formOneValue.fieldType == 'search'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                                                              :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)"
                                                              :disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1">
                                                        <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                   :disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1">
                                                        </el-button>
                                                    </el-input>
                                                    <!-- 制单日期 -->
                                                    <df-date v-else-if="formOneValue.fieldType == 'date'" @keyup.enter.native="nextFocus(formOneKey)" :isShowLong="false" :isdisabled="formOneValue.isChange == 0"
                                                             v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                                    <!-- 备注 -->
                                                    <el-input v-else :disabled="formOneValue.isChange == 0" @keyup.enter.native="nextFocus(formOneKey)" v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <template v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" >
                                                <el-form-item v-if="formOneValue.isShow==1" :key="formOneKey" :label="formOneValue.showField+':'" :prop="formOneValue.entityField">
                                                    <span v-if="formOneValue.fieldType == 'date'&&sendDataInfo[formOneValue.entityField]">
                                                        {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                    </span>
                                                    <span v-else-if="formOneValue.entityField == 'isOrder'">{{sendDataInfo[formOneValue.entityField]
													== 0 ? '否' : '是'}}</span>
                                                    <span v-else-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField]}}</a>
                                                    </span>
                                                    <span v-else>{{sendDataInfo[formOneValue.entityField]}}</span>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                    </el-form>
                                    <el-form :inline="true" size="mini" v-if="tables">
                                        <el-table size="mini" :data="sendDataInfo.preregisterdetails" border style="width: 100%" :height="mxHeight">
                                            <template v-for="(formOneValue,formOneKey) in mxForm">
                                                <el-table-column :prop="formOneValue.entityField" :min-width="formOneValue.fieldWeight" show-overflow-tooltip :label="formOneValue.showField" :key="formOneKey"
                                                                 v-if="formOneValue.isShow==1">
                                                    <template slot-scope="scope">
                                                        <span v-if="formOneValue.fieldType == 'date'">
                                                            <span v-if="scope.row[formOneValue.entityField]">
                                                                {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                                            </span>
                                                        </span>
                                                        <span v-else-if="formOneValue.isRift == 1">
                                                            <a @click="toDetail(scope.row[formOneValue.riftField])">{{scope.row[formOneValue.entityField]}}</a>
                                                        </span>
                                                        <span v-else>{{scope.row[formOneValue.entityField]}} </span>
                                                    </template>
                                                </el-table-column>
                                            </template>

                                        </el-table>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foot">
                    <div>
                        <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印
                        </el-button>
                        <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType!=2">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==0">保存</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==1">保存</el-button>
                    </div>
                </div>
            </div>

        </div>
        <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
            <PsRegisterExtraction ref="PsRegisterExtraction" :extractData="extractData1" @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import PsRegisterExtraction from "../byComponents/PsRegisterExtraction.vue";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
    name: "advancePaymentRegAction",
    props: ['actionData'],
    //import引入的组件需要注入到对象中才能使用
    components: {
        PsRegisterExtraction,
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            preregisterdetails: {},
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                abookCode: "",
                abookName: "",
                abookId: "",
                remark: "",
                checkNo: "",
                ppam: "",
                rgamId: "",
                ormId: "",
                ppamId: "",
                applyTime: "",
                opmId: "",
                opmName: "",
                depId: "",
                depName: "",
                salesId: "",
                salesName: "",
                smId: "",
                smName: "",
                sbiId: "",
                isOrder: "",
                payMoney: "",
                sfiSpayment: "",
                sfiAcollect: "",
                sbiNumber: "",
                psomId: "",
                createTime: "",
                updateTime: "",
                creater: "",
                applyState: "",
                psbkmId: "",
                registerTime: "",
                rgamCsalesman: "",
                rgamRapcusName: "",
                rgampurchaserName: "",
                rgamPurchaser: "",
                rgamRapcus: "",
                rgamRapdate: "",
                rgamRemark: 0,
                rgamSapdept: "",
                returnUnit: "",
                preregisterdetails: [],
                rgamReserves1: "",
                rgamReserves2: "",
                rgamReserves3: "",
                rgamReserves4: "",
                rgamReserves5: "",
                rgamReserves6: "",
                // totalCount: 0,
                // totalMoney: 0,
                // totalNumber: 0,
                smId: "",
                smName: "",
                opmId: "",
                opmName: "",
                salesId: "",
                salesName: "",
                depId: "",
                depName: "",
            },

            selectedDetails: [],
            selectedDataIndex: 0,
            selectGoodsInfo: "",
            showTabs: "",
            formDataList: [],
            dictionariesData: {},
            userOneList: [],
            goodsList: [],
            editDateilsIndex: "",
            exId: "",
            seId: "",
            ceshi: "",
            dialogTitle: "",
            seWidth: "",
            height: "",
            exTitle: "",
            seTitle: "",
            seWidth: "",
            exWidth: "",
            DialogVisible: false,
            DialogExtract: false,
            newFormDataList: [],
            seType: "",
            smId: "",
            ppId: "",
            parentSearchData: {
                smId: "",
            },
            tables: false,
            mxHeight: 0,
            tabForm: [],
            mxForm: [],
            footForm: []
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {

    },
    //方法集合
    methods: {
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById('mainInfo')
            if (el) this.inputel = el.getElementsByTagName('input')
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == '' && this.inputel[index].disabled == false) {
                    this.inputel[index].focus()
                    break
                }
            }
        },
        // 输入框切换焦点
        nextFocus(index) {
            if (index >= (this.inputel.length - 1)) return
            var aindex = index + 1
            if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
                this.nextFocus(aindex)
                return
            }
            this.inputel[aindex].focus()
        },
        showPrintPlan() { // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData.printJurId)
            } else {
                return
            }
        },
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
            else this.$parent.$parent.$parent.toDetail(orderId)
        },
        openDateilsBox(row, column, event) {
            if (this.sendDataInfo.ppamId == "") {
                return this.$message({
                    message: "请先提取预付款申请单号",
                    type: "warning",
                });
            } else {
                if (row) {
                    console.log(row);
                    this.editDateilsIndex = row.index;
                    // this.detailsBox.title = "修改明细信息"
                    this.preregisterdetails = JSON.parse(JSON.stringify(row));
                } else {
                    this.preregisterdetails = {
                        ppadId: "",
                        psodId: "",
                        ppadNum: 0,
                        psprice: 0,
                        psMoney: 0,
                    };
                    // this.detailsBox.title = "新增明细信息";
                    this.sendDataInfo.preregisterdetails.push(this.preregisterdetails);
                }
            }
        },
        handleDrawerClose(done) {
            this.$confirm("确认关闭？")
                .then((_) => {
                    done();
                })
                .catch((_) => { });
        },
        calculation() {
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.preregisterdetails.forEach((item) => {
                // 含税金额
                item.psmoney = this.$common.getDecimalInfo(
                    3,
                    NP.times(item.psprice, item.rgdRetnumber)
                );
                // 金额
                item.money = this.$common.getDecimalInfo(
                    3,
                    NP.times(item.price, item.rgdRetnumber)
                );
                this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(
                    3,
                    NP.plus(this.sendDataInfo.totalMoney, item.psmoney)
                );
                this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(
                    1,
                    NP.plus(this.sendDataInfo.totalNumber, item.rgdRetnumber)
                );
            });
            this.sendDataInfo.totalCount =
                this.sendDataInfo.preregisterdetails.length;
        },
        onInput() {
            this.$forceUpdate();
        },
        async getDataByChen(val) {
            if (val != "" || val != undefined) {
                if (val.isOrder == 1) {
                    this.tables = true;
                } else if (val.isOrder == 0) {
                    this.tables = false;
                }
                for (let key in val) {
                    if (key == "arrlistbychen") {
                        this.sendDataInfo.preregisterdetails = val.arrlistbychen;
                    } else {
                        this.sendDataInfo[key] = val[key];
                    }
                }
                this.DialogExtract = false;
                this.$nextTick(() => {
                    this.nextFocus(this.seIndex)
                })
            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        // 提取方案Id, 索引(表格中), 标识
        openExComponents(eId, index, type) {
            console.log(eId, index, type);
            this.DialogExtract = true;
            this.exId = eId;
            this.seIndex = index;
            this.seType = type;
            this.ppId = "ppamId";
            this.extractData1 = {
                id: this.exId,
                ppId: this.ppId,
                idType: "ormId",
            };
        },
        //检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.parentSearchData[type] = this.sendDataInfo[type]
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
            this.$nextTick(() => {
                this.nextFocus(this.seIndex)
            })
        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 选择采购员
        selectUserOne(data) {
            data.forEach((item) => {
                if (item.opmId == this.sendDataInfo.rgamPurchaser) {
                    this.sendDataInfo.rgamSapdept = item.depId;
                    this.sendDataInfo.rgamSapdeptName = item.depName;
                }
            });
        },

        initActionBox(sendDataInfo) {
            this.$confirm("确定取消新增吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$common.delOrderInfo(this.sendDataInfo.ppamId)
                    this.dataActionBox.actionType = 0;
                    this.$emit('drawerCancel')
                    this.tables = false;
                    this.init();
                    this.$refs[sendDataInfo].resetFields();
                })
                .catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '取消关闭'
                    // });
                });
        },
        init() {
            for (let key in this.sendDataInfo) {
                if (key == "pisorderauxinf") {
                    this.sendDataInfo[key] = [];
                    for (let sonOne in this.sendDataInfo[key]) {
                        this.sendDataInfo[key][sonOne] = "";
                    }
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
            //pisorderauxinf
            this.sendDataInfo.preregisterdetails = [];
            this.sendDataInfo.registerTime = this.$moment().valueOf();
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.totalCount = 0;
        },
        // 提取采购退货草稿
        async extractData(data) {
            if (data.length >= 1) {
                var sendData = [];
                data.forEach((items) => {
                    sendData.push(items.psbkdId);
                });
                let responseData = await this.$http.extractPurchaseListOrder({
                    ids: sendData,
                });
                if (responseData.status == 200) {
                    this.sendDataInfo = responseData.result;
                    this.sendDataInfo.registerTime = this.$moment().valueOf();
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            }
        },

        async isShowData(name, value) {
            console.log(name);
            switch (name) {
                case "businessGoods":
                    var dataInfo = sessionStorage.getItem("selectBusinessGoodsEntryInfo");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.preregisterdetails.push({
                            bgmId: dataInfo.bgmId,
                            bgmName: dataInfo.bgmName,
                            packingInfo: packingInfo,
                            batchNumber: "",
                            cartonSize: "",
                            condId: 0,
                            unitPrice: 0,
                            bgfIntaxrate: dataInfo.busgoodfinance.bgfIntaxrate,
                            originalOrderAmount: 0,
                            packingUnit: "",
                            producedData: "",
                            remark: "",
                            returnAmount: 0,
                            rgdReserves1: "",
                            rgdReserves2: "",
                            rgdReserves3: "",
                            rgdReserves4: "",
                            rgdReserves5: "",
                            rgdReserves6: "",
                            taxAmount: 0,
                            taxPrice: 0,
                            validityData: "",
                        });
                    }
                    break;

                case "supplier":
                    var dataInfo = sessionStorage.getItem("selectSupplierData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.rgamRapcus = dataInfo.smId;
                        this.sendDataInfo.rgamRapcusName = dataInfo.smName;
                    }
                    console.log(dataInfo);
                    break;

                case "cargoOwner":
                    var dataInfo = sessionStorage.getItem("selectCargoOwnerData");
                    console.log(dataInfo);
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.pisorderauxinf.coId = dataInfo.coId;
                        this.sendDataInfo.pisorderauxinf.coName = dataInfo.coName;
                    }

                    break;
            }
        },

        openBox() {
            this.dataActionBox.actionType = this.actionData.cate
            this.formDataList = this.actionData.formData
            var oldData = this.actionData.oldData
            this.showTabs = this.actionData.formData[0].jciName
            this.filterMainField()
            this.init();
            this.getSpecialUser();
            this.getPartDictionariesData();
            this.$set(this.sendDataInfo, "rgamRapdate", this.$moment().valueOf())
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                for (let key in oldData) {
                    this.$set(this.sendDataInfo, key, oldData[key])
                }
            } else {
                this.tables = true
                this.dataActionBox.boxTitle = '查看信息'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                    this.initFocus();
                }, 16.7)
            });
        },
        sendDataAction(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    if (this.sendDataInfo.preregisterdetails.length <= 0) {
                        if (this.tables == true) {
                            this.$message({
                                message: "请添加明细",
                                type: "error",
                            });
                            return false;
                        }
                    }
                    this.sub();
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        async sub() {
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (this.dataActionBox.actionType == 0) {
                // 新增预付款
                var responseData = await this.$http.addRegister(sendData);
            } else {
                // 暂时没有编辑接口
                var responseData = await this.$http.setPurchaseReturn(sendData);
            }
            if (responseData.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit('drawerCancel')
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        deleteDetails(index) {
            console.log(this.selectedDataIndex);
            console.log(this.sendDataInfo.preregisterdetails.length);
            // this.sendDataInfo.preregisterdetails.splice(index,1)
            if (this.sendDataInfo.preregisterdetails.length > 0) {
                if (
                    this.selectedDataIndex == undefined ||
                    this.selectedDataIndex === ""
                ) {
                    return this.$message({
                        message: "请先选中明细",
                        type: "warning",
                    });
                } else {
                    this.sendDataInfo.preregisterdetails.splice(
                        this.selectedDataIndex,
                        1
                    );
                    this.selectedDataIndex = "";
                }
            } else {
                return this.$message({
                    message: "暂无可删除明细",
                    type: "warning",
                });
            }
        },

        // 获取供货员
        async getSpecialUser() {
            let responseData = await this.$http.getSpecialUser({ opmBuyer: 1 });
            if (responseData.status == 200) {
                this.userOneList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 获取字典数据
        async getPartDictionariesData() {
            let responseData = await this.$http.getPartDictionariesData({
                ids: [20, 21],
            });
            if (responseData.status == 200) {
                this.dictionariesData = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = []
            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    mainFormList.push(item)
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
                }
            })
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key))
                this.tabForm[i].jurconfigform = []
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
                }
            })
            var arr = [{ entityField: "preregisterdetails" }, { entityField: "pisorderauxinf" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
            this.$set(this.sendDataInfo, "registerTime", this.$moment().valueOf())
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox()
        })
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput()
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}

.mb {
    margin-bottom: 0;
}

.newInput {
    height: 28px;
    line-height: 28px;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
}
</style>